import { EarthIcon } from "@assets/icons/home/EarthIcon";
import { useInViewport } from "@design-system/hooks";
import { Stat } from "@modules/home/data/mockData";
import { trans } from "@mongez/localization";
import { MapLegend } from "./MapLegend";
import { StatsGrid } from "./StatsGrid";

type StatisticsMapSectionProps = {
  stats: Stat[];
};

/** Parent section you already use */
export function StatisticsMapSection({ stats }: StatisticsMapSectionProps) {
  const { ref, isInView } = useInViewport<HTMLDivElement>();

  return (
    <section ref={ref} className="bg-[#00081C]">
      <div className="!pe-0 lg:container">
        <h2 className="container py-3 text-clamp-title lg:hidden">
          {trans("statisticsAndMap.title")}
        </h2>
        <div className="flex flex-col items-center lg:flex-row lg:items-center lg:justify-between lg:gap-8 lg:pe-0">
          <div className="w-full max-lg:container max-lg:order-2 max-lg:py-10 lg:w-auto">
            <StatsGrid isInView={isInView} stats={stats} />
          </div>
          <div className="relative z-20 w-full">
            <EarthIcon
              className="w-full max-sm:max-h-[500px]"
              isInView={isInView}
            />
            <div className="absolute inset-0">
              <MapLegend />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
